import React from 'react';
import Form from '@rjsf/core';
import { noop } from 'rxjs';
import { defaultValidator } from '../../utils/json-schema-validator/validator';

/*
// CRITERIA SCHEMA = [String]
// [
//  'criteria_1',
//  'criteria_2',
//  ...
// ]
//
 */
export const InputByCriteria = ({
  criteria = {},
  criteriaGroupName,
  submitForm = noop,
  formActions,
}) => {
  const { display_names, fields } = criteria;
  const properties = {
    type: 'string',
    title: 'Search by',
    enum: display_names,
  };
  if (display_names.length === 1) properties.default = display_names[0];
  const oneOfConditions = fields.map((field) => ({
    properties: {
      criteria: { enum: [field.display_name] },
      [field.field_name]: {
        type: 'string',
        title: field.display_name,
      },
    },
    required: [field.field_name],
  }));

  const schema = {
    title: criteriaGroupName,
    type: 'object',
    properties: {
      criteria: properties,
    },
    required: ['criteria'],
    dependencies: {
      criteria: {
        oneOf: oneOfConditions,
      },
    },
  };

  const uiSchema = {
    criteria: {
      'ui:widget': 'radio',
      'ui:options': {
        inline: false,
      },
    },
  };

  const handleSubmit = ({ formData }) => {
    /* Form data will look like
    // {
    //  criteria: 'Display Name',
    //  field_name: 'search input value',
    // } */
    const currentFormDisplayName = formData.criteria;
    const fieldOption = criteria.fields.find(
      (field) => field.display_name === currentFormDisplayName,
    );
    const criteriaSearchSlug = fieldOption.field_name;

    submitForm({
      key: criteriaSearchSlug,
      value: formData[criteriaSearchSlug],
    });
  };

  return (
    <Form
      schema={schema}
      uiSchema={uiSchema}
      validator={defaultValidator}
      onSubmit={handleSubmit}
    >
      {formActions}
    </Form>
  );
};
